import * as t from "io-ts";
import { UUID as uuidCodec } from "io-ts-types/UUID";

import { stringEnumCodec } from "../codecs";
import { NpsUserKind } from "../entity/types/nps";
import { HttpMethod } from "../helpers/http";

import { makeRouteSpec } from ".";

export { NpsUserKind };

export const npsUserKindCodec = stringEnumCodec({
  name: "NpsUserKind",
  enumObject: NpsUserKind,
});

const npsBaseBodyCodec = t.intersection([
  t.type({
    userKind: npsUserKindCodec,
  }),
  t.partial({
    nonprofitId: uuidCodec,
  }),
]);

export const saveNpsShownRouteSpec = makeRouteSpec({
  path: "/me/nps/shown",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({}),
  paramsCodec: t.type({}),
  bodyCodec: npsBaseBodyCodec,
  responseBodyCodec: t.type({}),
});

export const saveNpsScoreRouteSpec = makeRouteSpec({
  path: "/me/nps/score",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({}),
  paramsCodec: t.type({}),
  bodyCodec: t.intersection([
    npsBaseBodyCodec,
    t.type({
      score: t.number,
    }),
  ]),
  responseBodyCodec: t.type({}),
});

export const saveNpsAnswersRouteSpec = makeRouteSpec({
  path: "/me/nps/answers",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({}),
  paramsCodec: t.type({}),
  bodyCodec: t.intersection([
    npsBaseBodyCodec,
    t.type({
      question: t.string,
      answer: t.unknown,
    }),
  ]),
  responseBodyCodec: t.type({}),
});
